import { useQuery } from '@apollo/client';
import * as React from 'react';

import Error from './../../components/layout/Error';
import Loading from './../../components/layout/Loading';

export interface IGraphQLQueryProps {
    onResult?: (data?: any) => void;
    onResultReturnData?: boolean;
    fetchPolicy?: any;
}

interface IProps extends IGraphQLQueryProps {
    hideLoadingIndicator?: boolean;
    variables: any;
    query: any;
    dataProp: string;
    renderFetchedData: (data: any, refetch?: () => void) => any;
    children?: any;
}

const DetailQueryContainer: React.FC<IProps> = ({
    onResult,
    onResultReturnData,
    dataProp,
    variables,
    renderFetchedData,
    query,
    fetchPolicy,
    hideLoadingIndicator,
}) => {
    const { data, loading, error, refetch } = useQuery(query, {
        variables,
        fetchPolicy,
    });

    React.useEffect(() => {
        if (data && onResult) {
            onResultReturnData ? onResult(data[dataProp]) : onResult();
        }
    }, [data, onResult, onResultReturnData, dataProp]);

    if (loading) {
        return !hideLoadingIndicator && <Loading />;
    }
    if (error) {
        return <Error>Fetch data error</Error>;
    }

    return renderFetchedData(dataProp ? data[dataProp] : data, refetch);
};

export default DetailQueryContainer;
